import React from "react";
import PolicyLayout, { Section, Bullets } from "@/components/PolicyLayout";
import { AlertTriangle } from "lucide-react";

export default function TermsConditions() {
  return (
    <PolicyLayout title="Terms & Conditions" tagline="Legal · Terms" updated="Feb 2026">
      <p>
        Welcome to Teuralink. By accessing our website or purchasing our products, you agree to these Terms & Conditions.
      </p>

      <Section n={1} title="About Teuralink">
        <p>
          Teuralink provides premium commemorative Moon and Mars gift experiences through personalized
          certificates, registry entries, maps, and collectible gift packages.
        </p>
      </Section>

      <Section n={2} title="Nature of Our Products">
        <div className="p-5 border border-amber-500/30 rounded-xl bg-amber-500/5 mb-4 flex gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-300 shrink-0 mt-0.5" />
          <div>
            <div className="overline text-amber-300 mb-1">Important Notice</div>
            <p>
              All products sold by Teuralink are commemorative novelty gifts intended solely for gifting,
              collecting, entertainment, and personal enjoyment.
            </p>
          </div>
        </div>
        <p className="mb-2">Purchasing from Teuralink does not:</p>
        <Bullets items={[
          "Grant legal ownership of land on the Moon or Mars",
          "Transfer property rights",
          "Create government-recognized ownership",
          "Convey rights recognized under international law",
        ]} />
        <p className="mt-4">
          All registrations exist exclusively within the Private Teuralink Commemorative Registry.
        </p>
      </Section>

      <Section n={3} title="Customer Acknowledgement">
        <p className="mb-2">By placing an order, you acknowledge and agree that:</p>
        <Bullets items={[
          "Your purchase is symbolic and commemorative.",
          "You understand no legal property rights are transferred.",
          "You have read and accepted these Terms.",
        ]} />
      </Section>

      <Section n={4} title="Pricing">
        <p>All prices are displayed in Indian Rupees (INR) unless otherwise stated.</p>
        <p className="mt-2">Prices may change without prior notice.</p>
      </Section>

      <Section n={5} title="Orders">
        <p className="mb-2">
          Teuralink reserves the right to accept, reject, cancel, or limit any order for reasons including but
          not limited to:
        </p>
        <Bullets items={[
          "Pricing errors",
          "Fraud prevention",
          "Product availability",
          "Technical issues",
        ]} />
      </Section>

      <Section n={6} title="Personalization">
        <p>
          Customers are responsible for providing accurate spelling of names, addresses, and other personalization details.
        </p>
        <p className="mt-2">Orders cannot be modified after production begins.</p>
      </Section>

      <Section n={7} title="Shipping">
        <p>Estimated delivery times are provided for convenience only.</p>
        <p className="mt-2">
          Delays caused by courier services, customs, weather, or other circumstances beyond our control
          do not constitute grounds for compensation.
        </p>
      </Section>

      <Section n={8} title="Intellectual Property">
        <p className="mb-2">All content including:</p>
        <Bullets items={[
          "Certificates",
          "Registry Designs",
          "Website Content",
          "Graphics",
          "Logos",
          "Software",
          "Product Designs",
        ]} />
        <p className="mt-3">
          are the exclusive property of Teuralink and may not be reproduced without written permission.
        </p>
      </Section>

      <Section n={9} title="Limitation of Liability">
        <p>
          Teuralink shall not be liable for indirect, incidental, consequential, or special damages arising
          from use of our website or commemorative products.
        </p>
      </Section>
    </PolicyLayout>
  );
}
